module.exports = __webpack_public_path__ + "img/IDC.7a5cdf37.png";